"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInlineFeedback = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InlineFeedbackMixin = require("../../mixins/components/InlineFeedbackMixin");
var StyledInlineFeedback = /*#__PURE__*/_styledComponents.default.p.withConfig({
  displayName: "StyledInlineFeedback",
  componentId: "c11n-8-107-0__sc-jcmz56-0"
})(["", ""], _InlineFeedbackMixin.InlineFeedbackMixin);
exports.StyledInlineFeedback = StyledInlineFeedback;